import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const formatDate = (isoString) => {
  if (!isoString) return "";
  return new Date(isoString).toLocaleDateString("en-US", {
    year: "numeric", month: "2-digit", day: "2-digit",
  });
};

const TRANSACTION_TYPE_OPTIONS = [
  { value: "ContractItemPayment",          label: "Contract Item Payment" },
  { value: "ContractItemQuantityBalance",  label: "Contract Item Quantity Balance (Q)" },
  { value: "ContractItemAnticipatedChange",label: "Contract Item Anticipated Change (A)" },
  { value: "ContractItemFinalBalance",     label: "Contract Item Final Balance (F)" },
];

class QHeader extends Component {
  render() {
    const { qSheet, tab, jobStamp, calculatedBy, checkedBy, checkedOn,
            badge, startDate, endDate, estimateNumber,
            isSegregated, isDraft, onToggleSegregation } = this.props;

    const projectEA   = tab?.projectEA ?? jobStamp?.fullEA ?? "";
    const itemNo      = tab?.itemNo ?? "";
    const description = tab?.description ?? "";
    const calculatedOn = formatDate(qSheet?.calculatedOn);
    const sheetNumber = qSheet?.sheetNumber != null ? qSheet.sheetNumber : "(Draft)";
    const fileNo     = qSheet?.fileNo ?? "";
    const isStructures = qSheet?.isStructuresItem ?? false;
    const txType      = qSheet?.intendedTransactionType ?? "ContractItemPayment";

    const itemLabel = itemNo && description
      ? `#${itemNo} \u2013 ${description}`
      : itemNo
        ? `Item ${itemNo}`
        : description;

    return (
      <div className="card m-2">
        <div className="card-body">

          {/* ── Heading: title + estimate # + badge + period───────────── */}
          <div className="d-flex align-items-bottom mb-3">
            <h5 className="mb-0 mr-2">Quantity Calculations</h5>
            {badge && (
              <span className={`span-bubble p-1 px-2 ${badge.className}`}>
                {badge.label}
              </span>
            )}
            {isStructures && (
              <span className="span-bubble p-1 px-2 bg-warning text-dark ml-2">
                Structures Item
              </span>
            )}
            <span className="ml-auto" style={{ fontWeight: "bold", fontSize: "0.9em" }}>
              Estimate #{estimateNumber}  |  Pay Period: {startDate}&nbsp;&ndash;&nbsp;{endDate}
            </span>

          </div>

          {/* ── Row 1: EA + Pay Period + File No ────────────────────────────── */}
          <div className="form-row align-items-center mb-2">
            <label className="col-form-label col-form-label-sm text-right pr-2" style={{ width: "75px" }}><b>EA:</b></label>
            <div className="col-2">
              <input type="text" className="form-control form-control-sm" value={projectEA} disabled />
            </div>
            <div className="col" />
            <label className="col-auto col-form-label col-form-label-sm pr-1"><b>File No:</b></label>
            <div className="col-3">
              <input type="text" className="form-control form-control-sm" value={fileNo} disabled />
            </div>
          </div>

          {/* ── Item + Calculated By ────────────── */}
          <div className="form-row align-items-center mb-2">
            <label className="col-form-label col-form-label-sm text-right pr-2" style={{ width: "75px" }}><b>Item:</b></label>
            <div className="col-6">
              <input type="text" className="form-control form-control-sm" value={itemLabel} disabled />
            </div>
            <div className="col" />
            <label className="col-auto col-form-label col-form-label-sm pr-1"><b>Calculated By:</b></label>
            <div className="col-2">
              <input type="text" className="form-control form-control-sm" value={calculatedBy ?? ""} disabled />
            </div>
            <div className="col-1 pl-1">
              <input type="text" className="form-control form-control-sm" value={calculatedBy ? calculatedOn : ""} disabled />
            </div>
          </div>

          {/* ── Row 3: Segregation + Checked By────────────────────────────── */}
          <div className="form-row align-items-center mb-2">
            <div className="col-auto pl-3 d-flex align-items-center">
              <div className="col-form-label col-form-label-sm text-right pr-2" style={{ width: "65px" }}></div>
              <div className="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="segregationCheck"
                  checked={isSegregated ?? false}
                  onChange={(e) => { if (isDraft && onToggleSegregation) onToggleSegregation(e.target.checked); }}
                  disabled={checkedBy}
                />
                <label className="custom-control-label" htmlFor="segregationCheck">
                  Segregation
                </label>
              </div>
            </div>
            <div className="col" />
            <label className="col-auto col-form-label col-form-label-sm pr-1"><b>Checked By:</b></label>
            <div className="col-2">
              <input type="text" className="form-control form-control-sm" value={checkedBy ?? ""} disabled />
            </div>
            <div className="col-1 pl-1">
              <input type="text" className="form-control form-control-sm" value={checkedOn ?? ""} disabled />
            </div>
          </div>

          {/* ── Row 4: Transaction Type ──────────────────── */}
          {/*<div className="form-row align-items-center mb-2">
            <div className="col-auto pl-3">
              <label className="col-form-label col-form-label-sm pr-2"><b>CEM-6004 Type:</b></label>
            </div>
            <div className="col-3">
              <input
                type="text"
                className="form-control form-control-sm"
                value={TRANSACTION_TYPE_OPTIONS.find(o => o.value === txType)?.label ?? txType}
                disabled
              />
            </div>
          </div>*/}
        </div>
      </div>
    );
  }
}

export default QHeader;
